import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import en from '@angular/common/locales/en';
import { GlobalHttpInterceptorService } from './utilities/global-http-interceptor.service';
import {AuthGuardService as AuthGuard} from './auth/auth-guard.service';
import { IconSpriteModule } from 'ng-svg-icon-sprite';
import { UserIdleModule } from 'angular-user-idle';
import { EncryptionModule } from './encryption/encryption.module';
import { CountdownModule, CountdownGlobalConfig, CountdownConfig  } from 'ngx-countdown';
import { Config } from 'src/environments/config';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NgZorroAntdModule, NzNotificationServiceModule } from './utilities/ng-zorro-antd.module';
export function countdownConfigFactory(): CountdownConfig {
  return {};
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    CountdownModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgZorroAntdModule,
    NzNotificationServiceModule,
    AngularFirestoreModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    IconSpriteModule.forRoot({ path: 'filepath' }),
    UserIdleModule.forRoot({idle: 3600, timeout: 10, ping: 3600}),
    EncryptionModule.forRoot({
      clientPrivateKey: Config.clientPrivateKey,
      clientPublicKey: Config.clientPublicKey,
      serverPublicKey: Config.serverPublicKey
  })
  ],
  providers: [
    AuthGuard,
    { provide: NzDrawerRef, useValue: {} },
    { provide: NZ_I18N, useValue: en_US },
    { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpInterceptorService, multi: true  },
    { provide: CountdownGlobalConfig, useFactory: countdownConfigFactory },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
